export const webview = {
  webviewContent: 'Dies ist eine externe URL und wird in einem neuen Fenster geöffnet. Öffnen?',
  webviewButtonOpenTitle: 'Öffnen',
  webviewButtonCopyTitle: 'URL kopieren',
  webviewButtonOpenAgainTitle: 'Erneut öffnen',
  notifications: {
    urlCopied: 'URL kopiert!'
  }
}
